import { render, staticRenderFns } from "./ServeDisable.vue?vue&type=template&id=387f5850&scoped=true&"
import script from "./ServeDisable.vue?vue&type=script&lang=js&"
export * from "./ServeDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f5850",
  null
  
)

export default component.exports